/*
if long only: {"long":[{"priceToBreak":100.4,"candleDuration":1,"timeUnit":"MINUTES","achievedTimeFrame":false},{"priceToBreak":100.4,"candleDuration":5,"timeUnit":"MINUTES","achievedTimeFrame":false},{"priceToBreak":100.2,"candleDuration":5,"timeUnit":"DAYS","achievedTimeFrame":false},{"priceToBreak":99.8,"candleDuration":3,"timeUnit":"WEEKS","achievedTimeFrame":false},{"priceToBreak":99.6,"candleDuration":2,"timeUnit":"MONTHS","achievedTimeFrame":false}]} 	}

if short only: {"short":[{"priceToBreak":99.6,"candleDuration":1,"timeUnit":"MINUTES","achievedTimeFrame":false},{"priceToBreak":99.6,"candleDuration":5,"timeUnit":"MINUTES","achievedTimeFrame":false},{"priceToBreak":99.8,"candleDuration":5,"timeUnit":"DAYS","achievedTimeFrame":false},{"priceToBreak":100.2,"candleDuration":3,"timeUnit":"WEEKS","achievedTimeFrame":false},{"priceToBreak":100.4,"candleDuration":2,"timeUnit":"MONTHS","achievedTimeFrame":false}]} 	}

long and short:{"long":[{"priceToBreak":99.6,"candleDuration":1,"timeUnit":"MINUTES","achievedTimeFrame":false},{"priceToBreak":99.6,"candleDuration":5,"timeUnit":"MINUTES","achievedTimeFrame":false},{"priceToBreak":99.8,"candleDuration":5,"timeUnit":"DAYS","achievedTimeFrame":false},{"priceToBreak":100.2,"candleDuration":3,"timeUnit":"WEEKS","achievedTimeFrame":false},{"priceToBreak":100.4,"candleDuration":2,"timeUnit":"MONTHS","achievedTimeFrame":false},{"priceToBreak":99.6,"candleDuration":15,"timeUnit":"MINUTES","achievedTimeFrame":false}],
"short":[{"priceToBreak":99.6,"candleDuration":1,"timeUnit":"MINUTES","achievedTimeFrame":false},{"priceToBreak":99.6,"candleDuration":5,"timeUnit":"MINUTES","achievedTimeFrame":false},{"priceToBreak":99.8,"candleDuration":5,"timeUnit":"DAYS","achievedTimeFrame":false},{"priceToBreak":100.2,"candleDuration":3,"timeUnit":"WEEKS","achievedTimeFrame":false},{"priceToBreak":100.4,"candleDuration":2,"timeUnit":"MONTHS","achievedTimeFrame":false},{"priceToBreak":99.6,"candleDuration":15,"timeUnit":"MINUTES","achievedTimeFrame":false}]} 	}

this message needs a bit of refactoring from when I first made it. we really dont need the long or short stuff, just the array of ftfc's. I beg your patience :) 
thats why below im just getting if softOrder.long ? softOrder.long : softOrder.short

ideally, we would display it like you see in this link: https://usethinkscript.com/threads/rob-smiths-the-strat-indicator-for-thinkorswim.3312/page-11

so it look as follows I'd think... youd have one box per time frame, and it would have the time frame inside (1D for 1 day, 5m for 5min, 1M for 1 month). Perhaps it would say the price as well?
This would be in the top left of the screen. 

The following needs some refactoring as well, and although this will be pretty superfluous, it is pretty simple and inexpensive since this message is not sent up too often

the color of the box should be determined as follows:
if the current price is above the price to break for that time frame, it is green. if it is below, it is red. if it is equal, it is grey (this will obvs almost never happen)

so in the soft order messages, if it is the "long" ftfc's, and achieved time frame is true, then the box should be green.
If it is the "short" ftfc's, and achieved time frame is false, then the box should be green. (if the short time frame is not achieved, that means the price is above ftfc)

if you recieve both (for a long and short trade plan, just use the long ftfc's. as i said, it needs some refactoring. but this gets the job done)

*/
import PropTypes from 'prop-types';
import React from 'react';

export const FtfcWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'FTFC_FILTER',
    category: 'Setup Filter',
    type: 'Full Time Frame Continuity',
    domain: 'Time',
  };
  //const mas = softOrder.mas.emas; each object in the array has an id, periodlength, and the price. this message will update VERY frequently
  //const longFtfcs = softOrder.long; //this returns an array of FTFC's. Each item in the array has: {candleDuration, timeUnit, achievedTimeFrame}. if achieved time frame is true here, then box is green
  //const shortFtfcs = softOrder.short; //this returns an array of FTFC's. Each item in the array has: {candleDuration, timeUnit, achievedTimeFrame}. if achieved time frame is true here, then box is red
  
  return (
    <Component
      details={details}
      softOrder={softOrder}
      // mas={mas}
      // longFtfcs={longFtfcs}
      // shortFtfcs={shortFtfcs}
      {...rest}
    />
  );
};

FtfcWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.any
};

